<script setup lang="ts">
    import { onMounted, ref, computed } from "vue"
    import { useRouter } from "vue-router"
    import { useCrudNavigation } from "~/composables"
    import { Alert } from "~/logic"

    const router = useRouter()

    const props = defineProps({
        resourceComponent: {
            type: [Object, Function],
        },
        store: {
            type: Function,
            required: true,
        },
        route: {
            type: [Object, null],
            required: true,
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
    })

    const storeInstance = props.store()
    const { navigateToEditPage } = useCrudNavigation(storeInstance.name)
    const isDeleting = ref(false)

    const canReschedule = computed(
        () => typeof storeInstance.rescheduleEvent === "function",
    )

    onMounted(async () => {
        await storeInstance.fetchOne(props.route?.params?.id)
    })

    async function deleteItem() {
        const response = await Alert.confirm()
        if (response.isConfirmed) {
            isDeleting.value = true
            await storeInstance.delete(props.route?.params?.id)
            Alert.success("Suppression réussie")
            router.back()
        }
    }

    function edit() {
        navigateToEditPage(props.route?.params?.id)
    }

    function reschedule() {
        const id = parseInt(props.route?.params?.id)
        storeInstance.rescheduleEvent(id)
        router.push({ name: "manager.agenda" })
    }
</script>

<template>
    <v-container>
        <v-skeleton-loader
            v-if="!storeInstance.currentItem && !isDeleting"
            type="card@3"
        />

        <component
            :is="resourceComponent"
            v-else
            :item="storeInstance.currentItem"
        />
        <v-bottom-navigation color="teal" grow>
            <v-btn icon="mdi-close" @click="router.back()" />

            <v-btn v-if="showDelete" icon="mdi-delete" @click="deleteItem()" />
            <slot name="button" />
            <v-btn
                v-if="canReschedule"
                icon="mdi-calendar-arrow-right"
                @click="reschedule()"
            />
            <v-btn icon="mdi-pencil" @click="edit()" />
        </v-bottom-navigation>
    </v-container>
</template>
